import React from "react"
import styled from "styled-components"

import { Container } from "../global"

const Footer = () => (
  <FooterWrapper id="contato">
    <FooterColumnContainer>
      <FooterColumn>
        <span>Telefone</span>
        <ul>
          <li>(77) 99212-9166</li>
        </ul>
      </FooterColumn>
      <FooterColumn>
        <span>Endereço</span>
        <ul>
          <li>R. Anísio Teixeira, 125. Urandi - BA</li>
          <li>
            <a href="https://goo.gl/maps/y8TXQWytw2LQfV9fA" target="_blank">
              Ver no mapa
            </a>
          </li>
        </ul>
      </FooterColumn>
    </FooterColumnContainer>
    <BrandContainer>
    <Logo>{new Date().getFullYear()} © UrandiNet</Logo>
    </BrandContainer>
  </FooterWrapper>
)

const FooterWrapper = styled.footer`
  background-color: white;
  margin: 80px 0 0;
  padding: 0 0 30px;
`

const Logo = styled.div`
  font-family: ${props => props.theme.font.normal};
  ${props => props.theme.font_size.small};
  color: ${props => props.theme.color.black.regular};
  text-decoration: none;
  letter-spacing: 1px;
  margin: 0;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  position: relative;
  z-index: 9;
  text-decoration: none;
  outline: 0px;
`

const BrandContainer = styled(Container)`
  position: relative;
  padding-top: 60px;
  padding-top: 60px;
  display: flex;
  align-items: flex-end;

  @media (max-width: ${props => props.theme.screen.sm}) {
  }
`
const FooterColumnContainer = styled(Container)`
  display: grid;
  grid-template-columns: 1fr 3fr;
  grid-column-gap: 32px;
  justify-content: start;
  @media (max-width: ${props => props.theme.screen.sm}) {
    grid-template-columns: 1fr 1fr;
    grid-gap: 32px;
  }
`
const FooterColumn = styled.div`
  span {
    font-size: 20px;
    font-family: ${props => props.theme.font.bold};
    color: ${props => props.theme.color.primary};
  }
  ul {
    list-style: none;
    margin: 16px 0;
    padding: 0;
    color: ${props => props.theme.color.black.regular};
    li {
      margin-bottom: 16px;
      font-family: ${props => props.theme.font.normal};
      font-size: 20px;
    }
  }
`

export default Footer
